import { Form, Input, Row, Switch, Tooltip } from "antd";
import { useState, useEffect, useMemo, useCallback, ReactNode } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { useGetEmailFormRules } from "../../../../../../lib/hooks/getEmailFormRules";

type ToggleAlternateEmailProps = {
  hasAlternateEmail: boolean;
};

export const ToggleAlternateEmail = ({ hasAlternateEmail }: ToggleAlternateEmailProps) => {
  const [isAddAlternateEmail, setIsAddAlternateEmail] = useState<boolean>(false);

  const { rules } = useGetEmailFormRules();

  const formattedRules = useMemo(() => rules.slice(0, -1), [rules]);

  useEffect(() => {
    setIsAddAlternateEmail(hasAlternateEmail);
  }, [hasAlternateEmail]);

  const toggleEmail = useCallback((): void => {
    setIsAddAlternateEmail(!isAddAlternateEmail);
  }, [isAddAlternateEmail]);

  const label = useMemo((): ReactNode => {
    return (
      <Row className="align-center">
        Alternate Email
        {hasAlternateEmail && (
          <Form.Item name="isAlternateEmailForReceiving" valuePropName="checked" noStyle>
            <Switch className="ml-2" size="small" title="Enable alternate email for emails receiving" />
          </Form.Item>
        )}
        <CloseOutlined className="ml-2 logo-cursor" onClick={toggleEmail} />
      </Row>
    );
  }, [hasAlternateEmail, toggleEmail]);

  return !isAddAlternateEmail ? (
    <p className="my-0 text-sm w-500 logo-cursor card-header" onClick={toggleEmail}>
      + Alternate Email
    </p>
  ) : (
    <Form.Item label={label} name={["alternativeEmail"]} className="w-100 mb-0" rules={formattedRules}>
      <Input />
    </Form.Item>
  );
};
